import axios from 'axios';
import { createAsyncThunk, createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { appendCriteriaEquals, appendCriteriaIn, appendPageable, readPagedRows, } from '../utils/spring-api';
import { serializeAxiosError, resolveAsyncThunkErrorMessage, beginReportFetch, isStaleReportRequest, isAbortedThunkError } from './reducer.utils';
const initialState = {
    loading: false,
    errorMessage: null,
    report: [],
    totalItems: 0,
    activeRequestId: null,
};
const apiUrl = API_ROUTES.qstat.agentProductivity;
function buildParams({ username, usernames, startDate, endDate, page, size, }) {
    const params = new URLSearchParams();
    appendPageable(params, page, size);
    const names = usernames?.length ? usernames : username?.trim() ? [username.trim()] : [];
    appendCriteriaIn(params, 'username', names);
    appendCriteriaEquals(params, 'startDate', startDate);
    appendCriteriaEquals(params, 'endDate', endDate);
    return params;
}
export async function fetchAgentProductivityReportRows(query, options) {
    const params = buildParams(query);
    const qs = params.toString();
    const requestUrl = qs ? `${apiUrl}?${qs}` : apiUrl;
    const res = await axios.get(requestUrl, { signal: options?.signal });
    return readPagedRows(res.data, res.headers);
}
export const getAgentProductivityReport = createAsyncThunk('agentProductivityReport/fetch', async (query, { signal }) => fetchAgentProductivityReportRows(query, { signal }), { serializeError: serializeAxiosError });
export const AgentProductivityReportSlice = createSlice({
    name: 'agentProductivityReport',
    initialState: initialState,
    reducers: {
        reset() {
            return initialState;
        },
    },
    extraReducers(builder) {
        builder
            .addMatcher(isFulfilled(getAgentProductivityReport), (state, action) => {
            if (isStaleReportRequest(state, action))
                return;
            state.loading = false;
            state.report = action.payload.rows;
            state.totalItems = action.payload.total;
        })
            .addMatcher(isPending(getAgentProductivityReport), (state, action) => {
            beginReportFetch(state, action, () => {
                state.report = [];
            });
        })
            .addMatcher(isRejected(getAgentProductivityReport), (state, action) => {
            if (isStaleReportRequest(state, action))
                return;
            if (isAbortedThunkError(action.error))
                return;
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { reset } = AgentProductivityReportSlice.actions;
export default AgentProductivityReportSlice.reducer;
